// extracted by mini-css-extract-plugin
export var footer = "DKY1Ejxi";
export var container = "bejUyJDM";
export var logoContainer = "YFr0hlv3";
export var ticks = "YZSB1dnl";
export var tickContainer = "m4DZ0DHt";